export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=343f7c5c"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/index.vue?vue&type=template&id=343f7c5c
// module id = kXWI
// module chunks = 0